export default __webpack_public_path__ + "static/media/file_icon.16566b64.svg";